export const MEUSNIDUS_BASE_URL_FROM_HOST =
  window.location.host === 'meusnidus-v2.appchoose.io'
    ? 'https://meusnidus.appchoose.io'
    : 'https://meusnidus.appchoose.co';

export const BRAND_BASE_URL_FROM_HOST =
  window.location.host === 'meusnidus-v2.appchoose.io'
    ? 'https://mychoose.appchoose.io'
    : 'https://mychoose.appchoose.co';

export const BASE_URL_FROM_HOST =
  window.location.host === 'meusnidus-v2.appchoose.io'
    ? 'https://appchoose.io'
    : 'https://appchoose.co';

export const getHubspotUrl = ({
  hubspotId,
  hubspotSelectionId,
}: {
  hubspotId?: string | null;
  hubspotSelectionId?: string | null;
}) => {
  return hubspotSelectionId
    ? `https://app.hubspot.com/contacts/4364491/record/2-31111047/${hubspotSelectionId}`
    : `https://app.hubspot.com/contacts/4364491/deal/${hubspotId}`;
};

export const getRelativeAssetUrl = (url: string) => {
  return url.replace(
    /^https:\/\/storage.googleapis.com\/(public|images).appchoose.(co|io)\//,
    '',
  );
};
